import { render, staticRenderFns } from "./cert-detail.vue?vue&type=template&id=cf96fcd6&scoped=true&"
import script from "./cert-detail.vue?vue&type=script&lang=js&"
export * from "./cert-detail.vue?vue&type=script&lang=js&"
import style0 from "./cert-detail.vue?vue&type=style&index=0&id=cf96fcd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf96fcd6",
  null
  
)

export default component.exports